module.exports = __webpack_public_path__ + "static/media/sutherlandLogo.9a5b9a35.svg";